import { CatalogContext, XColumn } from '@records/catalog/extension.model';
import { WithContext } from 'projects/miq/catalog/src/lib/extension/framework';
import { IOption } from '@shared/models/icommons.model';

export interface CatalogColumnExtensionFrame<T, C> {
  [key: string]: Partial<T> | WithContext<C, T>;
}

export const EXTENDED_COLUMNS: CatalogColumnExtensionFrame<XColumn, CatalogContext> = {
  attribute_name: {
    lookupCategory: '/audit/lookup/ref?column=attribute_name',
    displayFn: (record: Record<string, any>, _: any, _u: any, column: any) => {
      const lookupForEntity: IOption[] = column?.values?.[record?.entity] || [];
      const cellValue = record['attribute_name'];
      const displayValue = lookupForEntity.find(option => option.key === cellValue);
      return displayValue?.value || cellValue;
    },
  },
};
